// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.appendTag .el-input-group__append {\n  background-color: #00A551;\n  color: #fff;\n  border-color: #00A551;\n}\n", ""]);
// Exports
module.exports = exports;
